export default __webpack_public_path__ + "static/media/hht2_ep17_timeline_q01_a.b76679d8.png";